import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import axios from "axios";
import Footer from '../components/Footer'; // Import the Footer component

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    mobile: '',
    inquiryType: 'Services', // Default selected option
    inquiry: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [emailError, setEmailError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === 'email') {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      setEmailError(emailPattern.test(value) ? '' : 'Please enter a valid email address');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (Object.values(formData).some(field => !field)) {
      setError('All fields are required.');
      return;
    }
    if (emailError) {
      setError('Please correct the errors before submitting.');
      return;
    }
    setError('');

    try {
      const response = await axios.post('/api/contact', formData);
      if (response.status === 200) {
        setSubmitted(true);
        setFormData({ firstName: '', lastName: '', email: '', mobile: '', inquiryType: 'Services', inquiry: '' });
      } else {
        setError('Failed to send message. Please try again later.');
      }
    } catch (error) {
      setError('An error occurred. Please check your network and try again.');
    }
  };

  return (
    <>
      <Container className="mt-5 d-flex flex-column align-items-center">
        <Row className="text-center mb-4">
          <Col>
            <h1 className="fw-bold text-dark display-4">Contact Us</h1>
            <p className="text-muted lead">Fill out the form below and we will get back to you as soon as possible.</p>
          </Col>
        </Row>

        {error && <Alert variant="danger">{error}</Alert>}
        {submitted && <Alert variant="success">Your inquiry has been submitted successfully!</Alert>}

        {/* Centered Form Container */}
        <Row className="justify-content-center w-100">
          <Col md={6} sm={10} xs={12}> 
            <div className="p-4 shadow rounded bg-light">
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>First Name <span style={{ color: 'red' }}>*</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Last Name <span style={{ color: 'red' }}>*</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Email <span style={{ color: 'red' }}>*</span></Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="example@email.com"
                  />
                  {emailError && <small style={{ color: 'red' }}>{emailError}</small>}
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Mobile <span style={{ color: 'red' }}>*</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Email Regarding: <span style={{ color: 'red' }}>*</span></Form.Label>
                  <Form.Select name="inquiryType" value={formData.inquiryType} onChange={handleChange} required>
                    <option value="Services">Services</option>
                    <option value="Careers">Careers</option>
                    <option value="Partnerships">Partnerships</option>
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Inquiry <span style={{ color: 'red' }}>*</span></Form.Label>
                  <Form.Control as="textarea" rows={4} name="inquiry" value={formData.inquiry} onChange={handleChange} required />
                </Form.Group>

                <div className="d-flex justify-content-center">
                  <Button
                    type="submit"
                    className="px-4 py-2 fw-bold shadow-sm"
                    style={{
                      background: '#333',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      transition: 'all 0.3s ease',
                    }}
                    onMouseEnter={(e) => e.target.style.background = '#555'}
                    onMouseLeave={(e) => e.target.style.background = '#333'}
                    onMouseDown={(e) => e.target.style.transform = 'scale(0.98)'}
                    onMouseUp={(e) => e.target.style.transform = 'scale(1)'}
                    disabled={emailError !== ''}
                  >
                    Submit Inquiry
                  </Button>
                </div>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Footer Section */}
      <Footer />
    </>
  );
};

export default Contact;
